import { useLayoutEffect, useState } from 'react'
import { PC_BREAKPOINT } from '@weberus/utils'

/**
 * PC 넓이 인지 확인하는 hook
 * PC: 801px 이상
 */
const useIsPcWidth = () => {
  const [isPcWidth, setIsPcWidth] = useState(false)

  useLayoutEffect(() => {
    const mediaQuery = window.matchMedia(`(min-width: ${PC_BREAKPOINT}px)`)
    setIsPcWidth(mediaQuery.matches)

    const handleMediaQueryChange = (event: MediaQueryListEvent) => {
      setIsPcWidth(event.matches)
    }

    mediaQuery.addEventListener('change', handleMediaQueryChange)
    return () => {
      mediaQuery.removeEventListener('change', handleMediaQueryChange)
    }
  }, [])

  return { isPcWidth }
}

export default useIsPcWidth
